import { CONFIG } from "../config.js";

/**
 * Navbar Component
 * Navigation header with Liquid Glass Style
 */
export class Navbar {
  constructor() {
    this.currentPage = "reports";
    this.onNavigate = null;
    this.isMobileMenuOpen = false;
  }

  setNavigationCallback(callback) {
    this.onNavigate = callback;
  }

  render() {
    return `
      <header class="navbar" id="navbar">
        <div class="navbar-container">
          <div class="navbar-brand">
            <div class="logo-wrapper">
            <a href="/report" data-page="reports">
              <img src="https://tpserver.vientianetraffic.com/ImageUpload/logowite.png" 
                   alt="Logo" 
                   class="navbar-logo"
                   onerror="this.parentElement.style.display='none'">
            </a>
            </div>
            <a class="navbar-title" href="/report" data-page="reports">
            ບໍລິສັດ ທີປຶກສາບັນຊີ | ອິນທຣາ
            </a>
          </div>

          <nav class="navbar-nav" id="navbarNav">
            <a href="#" class="nav-item ${this.currentPage === "reports" ? "active" : ""}" data-page="reports">
              <span class="nav-icon">💎</span>
              <span class="nav-text">ລາຍງານ</span>
            </a>
            <a href="#" class="nav-item ${this.currentPage === "entry" ? "active" : ""}" data-page="entry">
              <span class="nav-icon">✨</span>
              <span class="nav-text">ບັນທຶກລາຍການ</span>
            </a>
            <a href="#" class="nav-item ${this.currentPage === "settings" ? "active" : ""}" data-page="settings">
              <span class="nav-icon">🔮</span>
              <span class="nav-text">ຕັ້ງຄ່າ</span>
            </a>
          </nav>

          <div class="navbar-mobile-toggle" id="navbarToggle" role="button" aria-label="Toggle navigation">
            <div class="hamburger-box">
              <span class="hamburger-inner"></span>
              <span class="hamburger-inner"></span>
              <span class="hamburger-inner"></span>
            </div>
          </div>
        </div>
      </header>
    `;
  }

  initialize() {
    this.attachEventListeners();
  }

  attachEventListeners() {
    // 1. Handle Link Clicks
    const navItems = document.querySelectorAll(".nav-item");
    navItems.forEach((item) => {
      item.addEventListener("click", (e) => {
        e.preventDefault();
        const page = item.dataset.page;
        this.navigateTo(page);

        // Close mobile menu immediately after selection
        this.toggleMobileMenu(false);
      });
    });

    // 2. Handle Toggle Button
    const toggleBtn = document.getElementById("navbarToggle");
    if (toggleBtn) {
      toggleBtn.addEventListener("click", (e) => {
        e.stopPropagation(); // Prevent document click from firing immediately
        this.toggleMobileMenu(!this.isMobileMenuOpen);
      });
    }

    // 3. Handle Click Outside (UX Improvement)
    document.addEventListener("click", (e) => {
      const nav = document.getElementById("navbarNav");
      const toggle = document.getElementById("navbarToggle");

      // If menu is open AND click is NOT inside nav AND NOT on toggle
      if (
        this.isMobileMenuOpen &&
        nav &&
        !nav.contains(e.target) &&
        !toggle.contains(e.target)
      ) {
        this.toggleMobileMenu(false);
      }
    });
  }

  toggleMobileMenu(forceState = null) {
    const nav = document.getElementById("navbarNav");
    const toggleBtn = document.getElementById("navbarToggle");

    // Determine new state
    this.isMobileMenuOpen =
      forceState !== null ? forceState : !this.isMobileMenuOpen;

    if (nav) {
      if (this.isMobileMenuOpen) {
        nav.classList.add("active");
        if (toggleBtn) toggleBtn.classList.add("active");
      } else {
        nav.classList.remove("active");
        if (toggleBtn) toggleBtn.classList.remove("active");
      }
    }
  }

  navigateTo(page) {
    this.currentPage = page;
    const navItems = document.querySelectorAll(".nav-item");

    navItems.forEach((item) => {
      if (item.dataset.page === page) {
        item.classList.add("active");
      } else {
        item.classList.remove("active");
      }
    });

    if (this.onNavigate) {
      this.onNavigate(page);
    }
  }
}
